/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { BadgeCheck, FileCheck2, RefreshCw, Undo2 } from 'lucide-react';
import { chamarApi } from '@/nucleo/auth/cliente-api';
import { Button } from '@/ui/base/button';

const NS = '/bff/v1/j08-s07-conciliar-publicar';
const moeda = (v: any) => Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

export function ConciliarPublicarPagamentoPage() {
  const [s, setS] = useState<any>();
  const [busy, setBusy] = useState(false);
  async function call(p: string, b?: any) {
    setBusy(true);
    try {
      const r = await chamarApi<any>(NS + p, { metodo: p === '/state' ? 'GET' : 'POST', corpo: b });
      setS(r.state);
    } finally {
      setBusy(false);
    }
  }
  useEffect(() => {
    void call('/state');
  }, []);
  if (!s)
    return (
      <main role="status" className="p-6">
        Carregando conciliação…
      </main>
    );
  const e = s.exportacoes[0];
  const q = s.conciliacoes.find((v: any) => v.exportacao_id === e?.id);
  const mov = e?.movimentos[0];
  const item = e?.itens.find((v: any) => v.id === mov?.item_id);
  const match = q?.matches.find((v: any) => v.movimento_id === mov?.id);
  const latest = q?.demonstrativos.at(-1);
  return (
    <main className="min-w-0 max-w-[calc(100vw-2rem)] space-y-5 overflow-hidden">
      <header>
        <h1 className="text-3xl font-semibold">
          <FileCheck2 className="mr-2 inline h-7 w-7" />
          {s.titulo}
        </h1>
        <p>{s.descricao}</p>
      </header>
      {s.alertas.map((a: any) => (
        <div role="alert" className="rounded-md border border-destructive p-3" key={a.codigo}>
          {a.mensagem} <span className="font-mono text-xs">{a.codigo}</span>
        </div>
      ))}
      {e && !q && (
        <section className="rounded-md border p-4">
          <h2 className="font-semibold">Retornos disponíveis</h2>
          <p>
            Protocolo {e.protocolo_externo} · {e.estado}
          </p>
          <Button
            disabled={busy}
            onClick={() =>
              void call('/verbs/iniciar_conciliacao', {
                exportacaoId: e.id,
                chaveIdempotencia: `conciliar-${e.id}`,
              })
            }
          >
            <RefreshCw className="mr-2 h-4 w-4" />
            Iniciar conciliação
          </Button>
        </section>
      )}
      {q && (
        <>
          <section className="space-y-3 rounded-md border p-4">
            <h2 className="font-semibold">
              Conciliação {q.estado} · versão {q.versao_atual}
            </h2>
            <p>
              {q.credenciado_nome} · competência {q.competencia}
            </p>
            {mov && (
              <article className="rounded border p-3">
                <strong>
                  Extrato {mov.identificador_externo} · {moeda(mov.valor)}
                </strong>
                <p>
                  Item externo {item?.identificador_externo} · {item?.estado}
                </p>
                {!match && (
                  <div className="flex flex-wrap gap-2">
                    <Button
                      variant="outline"
                      disabled={busy}
                      onClick={() =>
                        void call('/verbs/analisar_match', {
                          conciliacaoId: q.id,
                          movimentoId: mov.id,
                        })
                      }
                    >
                      Analisar sem seleção
                    </Button>
                    <Button
                      disabled={busy}
                      onClick={() =>
                        void call('/verbs/decidir_match', {
                          conciliacaoId: q.id,
                          movimentoId: mov.id,
                          itemId: item.id,
                          chaveIdempotencia: `match-${mov.id}`,
                        })
                      }
                    >
                      <BadgeCheck className="mr-2 h-4 w-4" />
                      Confirmar match explícito
                    </Button>
                  </div>
                )}
                {match && <p>Match confirmado · {match.criterio}</p>}
              </article>
            )}
            {match && (
              <Button
                disabled={busy}
                onClick={() =>
                  void call('/verbs/publicar_demonstrativo', {
                    conciliacaoId: q.id,
                    chaveIdempotencia: `publicar-${q.id}-v${Number(q.versao_atual) + 1}`,
                  })
                }
              >
                <FileCheck2 className="mr-2 h-4 w-4" />
                Publicar demonstrativo final
              </Button>
            )}
          </section>
          {latest && (
            <section className="space-y-2 rounded-md border p-4">
              <h2 className="font-semibold">{latest.numero} · publicado</h2>
              <p>
                Bruto {moeda(latest.bruto)} · ajustes {moeda(latest.ajustes)} · glosas{' '}
                {moeda(latest.glosas)}
              </p>
              <p>
                Retenções {moeda(latest.retencoes)} · exceções {moeda(latest.excecoes)} · movimentos
                posteriores {moeda(latest.movimentos_adicionais)}
              </p>
              <p className="text-lg font-semibold">Líquido reconciliado {moeda(latest.liquido)}</p>
              <p className="break-all font-mono text-xs">Hash {latest.hash}</p>
              {q.movimentosAdicionais.length === 0 && (
                <Button
                  variant="outline"
                  disabled={busy}
                  onClick={() =>
                    void call('/verbs/registrar_movimento_adicional', {
                      conciliacaoId: q.id,
                      movimentoOrigemId: mov.id,
                      tipo: 'ESTORNO',
                      valor: 10,
                      motivo: 'Estorno bancário posterior comprovado no extrato.',
                      identificadorExterno: 'ESTORNO-MOV-BANCO-2026-0001',
                      chaveIdempotencia: `estorno-${mov.id}`,
                    })
                  }
                >
                  <Undo2 className="mr-2 h-4 w-4" />
                  Registrar estorno posterior
                </Button>
              )}
            </section>
          )}
        </>
      )}
    </main>
  );
}
